// Quick notification component
export const QUICK_NOTIFICATION_COMPOMENT = {
  '1': 'Transaction',
  '2': 'Billing',
  '9': 'Rental plan billing',
};

// Notification ID
export const NOTIFICATION_ID = {
  TRANSACTION: 1,
  SHUTDOWN_IMAGE: 2,
  MACHINE_IS_RUNNING: 3,
  FIXED_RENTAL: 9,
};